import type { BlockRegistry, BlockTypeConfig } from './types';
import { richtextConfig } from './blocks/richtext';
import { headingConfig } from './blocks/heading';
import { imageConfig } from './blocks/image';
import { galleryConfig } from './blocks/gallery';
import { carouselConfig } from './blocks/carousel';
import { videoConfig } from './blocks/video';
import { faqConfig } from './blocks/faq';
import { contactFormConfig } from './blocks/contact-form';
import { ctaConfig } from './blocks/cta';
import { statsConfig } from './blocks/stats';
import { quoteConfig } from './blocks/quote';
import { dividerConfig } from './blocks/divider';
import { columnsConfig } from './blocks/columns';
import { spacerConfig } from './blocks/spacer';
import { listConfig } from './blocks/list';
import { codeConfig } from './blocks/code';
import { sectionConfig } from './blocks/section';
import { buttonConfig } from './blocks/button';

// Each config is typed as BlockTypeConfig<SpecificBlock>. The cast to BlockRegistry
// (Record<PageBlockType, BlockTypeConfig<PageBlock>>) is safe because none of the configs
// define `variants` at this stage, and registry consumers only call `createDefault()` /
// read toolbar/sheet — they never invoke Variant.apply with a mismatched data shape.
// The variance issue on Variant.apply (contravariant in T['data']) prevents a direct
// `satisfies` check without the cast.
export const blockRegistry: BlockRegistry = {
  richtext: richtextConfig as BlockTypeConfig,
  heading: headingConfig as BlockTypeConfig,
  image: imageConfig as BlockTypeConfig,
  gallery: galleryConfig as BlockTypeConfig,
  carousel: carouselConfig as BlockTypeConfig,
  video: videoConfig as BlockTypeConfig,
  faq: faqConfig as BlockTypeConfig,
  'contact-form': contactFormConfig as BlockTypeConfig,
  cta: ctaConfig as BlockTypeConfig,
  stats: statsConfig as BlockTypeConfig,
  quote: quoteConfig as BlockTypeConfig,
  divider: dividerConfig as BlockTypeConfig,
  columns: columnsConfig as BlockTypeConfig,
  spacer: spacerConfig as BlockTypeConfig,
  list: listConfig as BlockTypeConfig,
  code: codeConfig as BlockTypeConfig,
  section: sectionConfig as BlockTypeConfig,
  button: buttonConfig as BlockTypeConfig,
};

export type {
  BlockTypeConfig,
  BlockRegistry,
  ToolbarItem,
  SheetField,
  Variant,
  PageBlockType,
} from './types';
